import { $_app_server } from '@/_helpers'

export const typeService = {
  types
}

function types() {
  return $_app_server.get("public/types")
    .then(response => {
        return response.data
    })
}